export default __webpack_public_path__ + "static/sage-snap-frame-desktop-aea4558a4d74b5321b2763385b8bec08.gif";